/**
 * Extract a user-friendly error message from an API error
 *
 * @param error - The error to extract a message from
 * @returns A user-friendly error message
 *
 * @example
 * const errorMessage = getErrorMessage(error);
 * toast({ title: 'Error', description: errorMessage });
 */
export function getErrorMessage(error: unknown): string {
  if (error && typeof error === 'object') {
    // Check for ApiError with response.message (parsed ErrorResponse)
    if (
      'response' in error &&
      error.response &&
      typeof error.response === 'object'
    ) {
      const response = error.response as {
        message?: string;
        error?: string;
      };
      if (response.message) {
        return response.message;
      }
      if (response.error) {
        return response.error;
      }
    }
    // Check for ApiError with data.error (raw backend response)
    if ('data' in error && error.data && typeof error.data === 'object') {
      const data = error.data as { error?: string; message?: string };
      if (data.error) {
        return data.error;
      }
      if (data.message) {
        return data.message;
      }
    }
    // Check for direct message property
    if ('message' in error && typeof error.message === 'string') {
      return error.message;
    }
  }
  return 'An unexpected error occurred';
}
